import React from "react";
import { useEffect, useRef, useState } from "react";
import awtarImage from "./../../images/awtar-image.png"
function Topdistributor({ war_data }) {
    const modalRef = useRef(null);
    const [isModalVisible, setIsModalVisible] = useState(true);
    let userType = localStorage.getItem("user_type");
    // console.log('top modal')
    const handleCloseModal = () => {
        setIsModalVisible(false); // Hide the modal
        if (modalRef.current) {
            modalRef.current.classList.remove("show");
            modalRef.current.style.display = "none";
            document.body.classList.remove("modal-open"); // Remove Bootstrap's body class
            document.body.style.overflow = "auto";
        }
    };
    if (!isModalVisible || !war_data || !war_data.is_top_five || Object.keys(war_data.is_top_five).length === 0) {
        return null; // Don't render the modal if it's not visible
    }
    return (
        <>
            {userType !== 'rm' && userType !== 'admins' && war_data && war_data.is_top_five && Object.keys(war_data.is_top_five).length > 0 && (
                <div ref={modalRef} className="modal fade top-distributor-modal show" style={{ display: "block" }} id="Topdistmodal" tabIndex="-1" role="dialog" aria-modal="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content tdpmodal">
                            <div className="disributor-profile-box mt-5">
                                <p className="dtitle">Congratulations</p>
                                <p className="dtext">You're Now In</p>
                            </div>
                            <div className="topdistbox">
                                <p className="top5">Top 5</p>
                                <p className="dist">Distributor</p>
                            </div>
                            <div className="profileinfobox-dist mt-5">
                                <div className="imgboxdist">
                                    <img src={war_data.is_top_five.profile_pic || awtarImage} className="img-fluid profileimgdist" />
                                </div>
                                <div className="distinfox-box">
                                    <div className="dist1box">
                                        <span className="astratitle">Astra:</span> 
                                        {
                                            war_data.is_top_five.astra > 0 &&
                                            Array.from({ length: war_data.is_top_five.astra }).map((_, index) => (
                                                <img
                                                    key={index}
                                                    src="../images/BOR/brahmastra-stone1.png"
                                                    className="img-fluid astraimgstone"
                                                    alt="Astra"
                                                />
                                            ))
                                        }
                                        <span className="astranum">{war_data.is_top_five.astra}/3 Completed</span>
                                    </div>
                                    <div className="distpbox">
                                        <p className="distp">Points Earned:</p>
                                        <span className="distnum">{Math.round(war_data.is_top_five.points)}</span>
                                    </div>
                                    <div className="warbtnbox">
                                        <button onClick={handleCloseModal} className="warbtn" type="button" data-toggle="modal" data-target="#Topdistmodal" aria-label="Close">Go To War</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Topdistributor;